// export const API_ENDPOINT = 'http://cognitivintelligence.com:3003/api/v/1';
export const API_ENDPOINT = 'https://pyramid.cognitivintelligence.com/api/v/1';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOG_OUT = 'LOG_OUT';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const SET_USER_PROFILE = 'SET_USER_PROFILE';
